import styled from "styled-components";

export const StyledHeader = styled.div`
  &&& {
    h1 {
      color: ${props => props.theme.black};
      font-size: 46px;
      font-weight: normal;
      padding: 55px 35px;
      padding-bottom: 0;
      margin: 0;
    }
    h2 {
      font-weight: normal;
      padding: 0 35px;
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .smaller-header {
      font-size: 42px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SimpleReportHeader/style.js